import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CloseIcon } from '../../../assets/images/close-icon.svg';
import { InputText as PrimeReactInputText } from 'primereact/inputtext';
import { useState, useEffect } from 'react';
import './MatchBagDialog.scss';

const MatchBagDialog = ({
    visible,
    onHide,
    onSearch,
    bagBarcode = ''
}) => {
    const { t } = useTranslation();
    const [barcode, setBarcode] = useState(bagBarcode);

    useEffect(() => {
        if (visible) {
            setBarcode(bagBarcode);
        }
    }, [visible, bagBarcode]);

    const handleSearch = () => {
        if (onSearch) {
            onSearch(barcode);
        }
    };

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            header={t('cashoperations.matchBag')}
            className="match-bag-dialog"
            closable={true}
            closeIcon={<CloseIcon />}
            modal
            draggable={false}
            resizable={false}
            focusOnShow={true}
            appendTo={document.body}
            style={{ width: '520px' }}
            footer={
                <div className="match-bag-buttons">
                    <button
                        className="match-bag-button-primary"
                        onClick={handleSearch}
                    >
                        {t('cashoperations.search')}
                    </button>
                    <button
                        className="match-bag-button-secondary"
                        onClick={onHide}
                    >
                        {t('cashoperations.cancel')}
                    </button>
                </div>
            }
        >
            <div className="match-bag-form">
                <div className="match-bag-container">
                    <div className="match-bag-input-container">
                        <label className="match-bag-label">
                            {t('cashoperations.bagBarcode')}
                        </label>
                        <div className="match-bag-input-wrapper">
                            <PrimeReactInputText
                                id="bagBarcode"
                                value={barcode}
                                onChange={(e) => setBarcode(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        handleSearch();
                                    }
                                }}
                                autoFocus
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default MatchBagDialog;
